import axios from "axios";

//const CACHE_MAX_AGE = 600000;
const CACHE_MAX_AGE = 600000;

const cache = {};

export const setCache = (key, data) => {
  cache[key] = {
    data,
    timestamp: Date.now(),
  };
};

export const getCache = (key, maxAge) => {
  const entry = cache[key];
  if (entry && Date.now() - entry.timestamp < maxAge) {
    return entry.data;
  }
  return null;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
});

export function makeRequest(url, options) {
  const cachedData = getCache(url, CACHE_MAX_AGE);
  if (cachedData) {
    // If data is cached, return it without making the API call
    return Promise.resolve(cachedData);
  }

  const startTime = performance.now();

  return api(url, options)
    .then((response) => {
      const endTime = performance.now();
      const responseTime = endTime - startTime;
      // console.log(`API response time: ${responseTime} milliseconds`);
      if (response.status === 200) {
        // Cache the response data
        setCache(url, response.data);
      }
      return response.data;
    })
    .catch((error) => Promise.reject(error?.response?.data?.message ?? "Error"));
}
